module.exports = __webpack_public_path__ + "static/metodology-00c9b8680ed6e6f9d18237e08c675384.svg";